import ko from "knockout";

/**
 * categoryTooltipPopover Binding Handler
 *
 * Used to display and hide each category list item's tooltip on hover
 */

const initTooltipPopover = function (element, valueAccessor) {
    const categoryTagId = valueAccessor();

    element.addEventListener("mouseover", () => {
        const categoryTooltip = document.getElementById(
            "category-tooltip" + categoryTagId
        );
        categoryTooltip.hidden = false;
    });

    element.addEventListener("mouseout", () => {
        const categoryTooltip = document.getElementById(
            "category-tooltip" + categoryTagId
        );
        categoryTooltip.hidden = true;
    });
};

// Wrapper
ko.bindingHandlers.categoryTooltipPopover = {
    init: function (element, valueAccessor) {
        initTooltipPopover(element, valueAccessor);
    },
};
